import i18next from 'i18next';

export const getSamplingTypeLabel = (key: string) => {
  return i18next.t(`analysis.samplingTypes.${key}`);
};
